import { Button, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Checked, English, Hinid, UnChecked } from "../../Assets/icons";
import {
  getLocalStorageItem,
  localStorageConstants,
} from "../../Services/LocalStorageServices";
import { Routes } from "../../Utils/Constants/routes";
import LoginSignupSidePanel from "../Authentication/Components/Greetings";
import "./index.css";

const LandingPage: React.FC = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("i18nextLng")
  );

  const languageContinue = () => {
    setTimeout(() => {
      getLocalStorageItem(localStorageConstants.accessToken)?.length
        ? history.push(Routes.consent)
        : history.push(Routes.login);
    }, 2000);
  };

  const changeLanguage = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    i18n.changeLanguage(event.currentTarget.id);
    setSelectedLanguage(event.currentTarget.id);
  };

  return (
    <div className="signupRoot">
      <div className="sliderCss subPanelBorder">
        <LoginSignupSidePanel type="languageSelection" />
        <div className="signForm flexCustomCss linkAccountRoot">
          <div className="languageSelectRoot">
            <div className="row languagerow">
              <Typography.Text className="fontWeight600 font24">
                {t("lblChoose")}
              </Typography.Text>
              <Typography.Text className="font24 marginLeft8">
                {t("lblChooseLanguage")}
              </Typography.Text>
            </div>
            <Button
              onClick={changeLanguage}
              id="hi"
              className={`${
                selectedLanguage === "hi"
                  ? "selectedButton"
                  : "unSelectedButton"
              } row  alignCenter spaceBetween selectLanguage`}
            >
              <div className="row alignCenter">
                <Hinid />
                <div className="col justifyCenter alignStart marginleft10">
                  <Typography.Text
                    className={`${
                      selectedLanguage === "hi"
                        ? "selectedText"
                        : "unSelectedText"
                    } font16 fontWeight600`}
                  >
                    हिंदी
                  </Typography.Text>
                  <Typography.Text
                    className={`${
                      selectedLanguage === "hi"
                        ? "selectedText"
                        : "unSelectedText"
                    } font24 fontWeight600`}
                  >
                    नमस्ते
                  </Typography.Text>
                </div>
              </div>
              {selectedLanguage === "hi" ? <Checked /> : <UnChecked />}
            </Button>
            <Button
              onClick={changeLanguage}
              id="en"
              className={`${
                selectedLanguage === "en"
                  ? "selectedButton"
                  : "unSelectedButton"
              } row  alignCenter spaceBetween selectLanguage `}
            >
              <div className="row alignCenter">
                <English />
                <div className="col justifyCenter alignStart marginleft10">
                  <Typography.Text
                    className={`${
                      selectedLanguage === "en"
                        ? "selectedText"
                        : "unSelectedText"
                    } font16 fontWeight600`}
                  >
                    English
                  </Typography.Text>
                  <Typography.Text
                    className={`${
                      selectedLanguage === "en"
                        ? "selectedText"
                        : "unSelectedText"
                    } font24 fontWeight600`}
                  >
                    Hello there!
                  </Typography.Text>
                </div>
              </div>
              {selectedLanguage === "en" ? <Checked /> : <UnChecked />}
            </Button>
            <Button
              onClick={changeLanguage}
              id="mr"
              className={`${
                selectedLanguage === "mr"
                  ? "selectedButton"
                  : "unSelectedButton"
              } row  alignCenter spaceBetween selectLanguage marginBottom100`}
            >
              <div className="row alignCenter">
              <Hinid />
                <div className="col justifyCenter alignStart marginleft10">
                  <Typography.Text
                    className={`${
                      selectedLanguage === "mr"
                        ? "selectedText"
                        : "unSelectedText"
                    } font16 fontWeight600`}
                  >
                    मराठी
                  </Typography.Text>
                  <Typography.Text
                    className={`${
                      selectedLanguage === "mr"
                        ? "selectedText"
                        : "unSelectedText"
                    } font24 fontWeight600`}
                  >
                     नमस्कार
                  </Typography.Text>
                </div>
              </div>
              {selectedLanguage === "mr" ? <Checked /> : <UnChecked />}
            </Button>


            <Button
              onClick={languageContinue}
              className="commonButtonBackground primaryButton linkAccountNoAccounts primaryButtonWidth"
            >
              <Typography.Text className="font16 fontWeight600 languageConfirm">
                {t("lblContinue")}
              </Typography.Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
